import { ErrorType } from '../../../models/HttpError';
import { AppState } from '../../../redux/reducers';
import { GetPersonDisplayName } from '../Persons.Functions';
import { Person } from '../../../models/Entities/Person/Person';
import { PersonRelationshipViewModel } from '../../../models/Entities/Person/Relationship/PersonRelationshipModels';

// store
import * as PersonRelationshipsStore from '../../../redux/middleware/PersonRelationships.Middleware';
import * as PersonsStore from '../../../redux/middleware/Persons.Middleware';

export interface IProps {
  isOpen: boolean;
  openPanel: () => void;
  dismissPanel: () => void;
  PersonId: number;
  PersonType?: number | undefined;
  relationshipId?: number | undefined;
}

interface ConnectedProps {
  personName: string;
  isAdding: boolean | undefined;
  successAdding: boolean | undefined;
  failAdding: boolean | undefined;
  isUpdating: boolean | undefined;
  successUpdating: boolean | undefined;
  failUpdating: boolean | undefined;
  isLoadingPersons: boolean | undefined;
  error: ErrorType | undefined;
  relationship?: PersonRelationshipViewModel;
  availablePersons: Person[];
}

interface DispatchProps {
  CreatePersonRelationship: typeof PersonRelationshipsStore.actionCreators.CreatePersonRelationship;
  UpdatePersonRelationship: typeof PersonRelationshipsStore.actionCreators.UpdatePersonRelationship;
  GetAllPersons: typeof PersonsStore.actionCreators.GetAllPersons;
}

export type Props = IProps & ConnectedProps & DispatchProps;

export const mapStateToProps = (state: AppState, ownProps: IProps) => ({
  personName: GetPersonDisplayName(state.Persons?.list.find((person) => person.id === ownProps.PersonId)),
  isAdding: state.PersonRelationships?.isAddingNewOne,
  successAdding: state.PersonRelationships?.successAddingNewOne,
  failAdding: state.PersonRelationships?.failOnAddingNewOne,
  isUpdating: state.PersonRelationships?.isUpdatingOne,
  successUpdating: state.PersonRelationships?.successUpdatingOne,
  failUpdating: state.PersonRelationships?.failOnUpdatingOne,
  isLoadingPersons: state.Persons?.isLoadingAll,
  error: state.PersonRelationships?.error,
  relationship: state.PersonRelationships?.list.find(
    (item: PersonRelationshipViewModel) => item.id === ownProps.relationshipId
  ),
  // a person cannot be related to itself
  availablePersons: (state.Persons?.list ?? [])
    .filter((person: Person) => person.id !== ownProps.PersonId && !person.isDeleted)
    .slice()
    .sort((a: Person, b: Person) => (a.businessName || '').localeCompare(b.businessName || '')),
  ...ownProps
});

export const mapDispatchToProps = {
  ...PersonRelationshipsStore.actionCreators,
  ...PersonsStore.actionCreators
};
